import { useEffect } from 'react';
import SWWashingtonHero from './components/SWWashingtonHero';
import WhyChooseUs from './components/WhyChooseUs';
import VehicleShowcase from './components/VehicleShowcase';
import ServiceAreaCities from './components/ServiceAreaCities';
import SWWashingtonFaq from './components/SWWashingtonFaq';
import FinalCta from './components/FinalCta';
import TrustSignals from '../../components/feature/TrustSignals';
import { removeJsonLd } from '../../lib/schemaBuilder';
import { injectFAQSchema, removeFAQSchema } from '../../lib/safeSchema';
import { pageFaqs } from '../../mocks/pageFaqs';
import { useSEOHead } from '../../hooks/useSEOHead';

export default function UsedCarsSWWashingtonPage() {
  useSEOHead({
    title: 'Used Cars SW Washington | Long Beach, Ilwaco | Rockhound Auto',
    description: 'Quality used cars for southwest Washington buyers. Free delivery to Long Beach, Ilwaco, and Pacific County. Flat $250 doc fee, no dealer games, all cross-state paperwork handled.',
    keywords: 'used cars SW Washington, Long Beach WA cars, Ilwaco used cars, Oregon dealer SW Washington',
    canonicalUrl: 'https://rockhoundauto.com/used-cars-sw-washington',
    geoRegion: 'US-WA',
    geoPlacename: 'Southwest Washington',
  });

  useEffect(() => {
    injectFAQSchema(
      'schema-sw-washington-faq',
      pageFaqs.usedCarsSWWashington,
      'https://rockhoundauto.com/used-cars-sw-washington#faqpage'
    );

    return () => {
      removeFAQSchema('schema-sw-washington-faq');
    };
  }, []);

  return (
    <>
      <SWWashingtonHero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Expert Perspective Block */}
        <div className="mb-16 bg-gradient-to-br from-amber-50 to-orange-50 border-l-4 border-amber-500 rounded-lg p-6 shadow-sm">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-map-2-line text-2xl text-white"></i>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Why SW Washington Buyers Shop With Us</h3>
              <p className="text-gray-700 leading-relaxed">
                Washington buyers who purchase in Oregon still pay Washington state use tax when they register at home — that's the law, no exceptions. What they <em>do</em> save is our flat $250 doc fee vs. $300–$500+ at many Washington dealerships, plus they get access to our wider selection and no-pressure process. We're 10 minutes from Long Beach and Ilwaco and handle all cross-state registration paperwork seamlessly.
              </p>
            </div>
          </div>
        </div>
      </div>
      <TrustSignals variant="strip" />
      <WhyChooseUs />
      <VehicleShowcase />
      <SWWashingtonFaq />
      <ServiceAreaCities />
      <FinalCta />
    </>
  );
}
